module.exports = __webpack_public_path__ + "gl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gl.svg
// module id = 569
// module chunks = 0